export default __webpack_public_path__ + "static/media/GUARD.53368578.svg";